// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"39321886","617":"b12897c8","640":"00d23b00","796":"bea0fafe","815":"02a000f6"}[chunkId] + ".chunk.js";
};